import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import colors from '../../../../../../../constants/colors';
import HaizeaResidualImpactProbElement from './HaizeaResidualImpactProbElement';

export default function HaizeaResidualImpactProbBlock(props) {
  const { plantObligation } = props;
  const poLevel3 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level3
  );

  const getColorInherent = useCallback((argValue = 0) => {
    const value = Math.round(argValue);
    if (value <= 5) return 'success';
    if (value <= 10) return 'warning';
    return 'danger';
  }, []);

  const getColorResidual = useCallback((argValue = 0) => {
    const value = Math.round(argValue);
    if (value <= 3) return 'success';
    if (value <= 10) return 'warning';
    return 'danger';
  }, []);

  return (
    <Container>
      <HaizeaResidualImpactProbElement
        type="RI"
        color={getColorInherent(poLevel3?.[plantObligation]?.haizea?.RI ?? 0)}
        state={
          poLevel3?.[plantObligation]?.haizea?.RI ?? null
        }
      />
      <HaizeaResidualImpactProbElement
        type="RR"
        color={getColorResidual(poLevel3?.[plantObligation]?.haizea?.RR ?? 0)}
        state={
          poLevel3?.[plantObligation]?.haizea?.RR ?? null
        }
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  color: ${colors.primary};
  justify-content: center;
`;
